(function () {
    'use strict';

    angular
        .module('app')
        .factory('PasswordService', PasswordService);

    PasswordService.$inject = ['$http', '$q', '$cookies', '$rootScope', 'WebAPIUrl'];

    function PasswordService($http, $q, $cookies, $rootScope, WebAPIUrl) {
        var service = {};

        service.forgotPassword = forgotPassword;
        service.confirmResetPasswordEmail = confirmResetPasswordEmail;
        service.resetPassword = resetPassword;
        service.changePassword = changePassword;
        service.changeUserPassword = changeUserPassword;
        service.confirmEmail = confirmEmail;
        service.getStrength = function (pass) {
            return getStrength(pass);
        }

        return service;

        function forgotPassword(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ForgotPassword",
                data: userData,
            }).success(function (data, status, headers, cfg) {                
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err);
            });

            return deferred.promise;
        }

        function confirmResetPasswordEmail(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ConfirmResetPasswordEmail",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(status);
            });

            return deferred.promise;
        }

        function resetPassword(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ResetPassword",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (result) {                
                deferred.reject(result);
            });

            return deferred.promise;
        }

        function changePassword(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ChangePassword",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function changeUserPassword(userData) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ChangeUserPassword",
                data: userData,
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function confirmEmail(userName) {
            var deferred = $q.defer();
            $http({
                method: 'POST',
                url: WebAPIUrl + "/api/Account/ConfirmEmail?userName=" + userName
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(status);
            });

            return deferred.promise;
        }


        function getStrength(pass) {

            var score = 0;

            if (!pass)

                return score;


            // award every unique letter until 5 repetitions

            var letters = new Object();

            for (var i = 0; i < pass.length; i++) {

                letters[pass[i]] = (letters[pass[i]] || 0) + 1;

                score += 5.0 / letters[pass[i]];

            }


            // bonus points for mixing it up

            var variations = {

                digits: /\d/.test(pass),

                lower: /[a-z]/.test(pass),

                upper: /[A-Z]/.test(pass),

                nonWords: /\W/.test(pass),

            }


            var variationCount = 0;

            for (var check in variations) {

                variationCount += (variations[check] == true) ? 1 : 0;

            }

            score += (variationCount - 1) * 10;


            if (score > 100) score = 100;


            return parseInt(score);

        }



        //return {

        //    getStrength: function (pass) {

        //        return getStrength(pass);

        //    }

        //}

     }



})();